import React from 'react';
import { StyledCenterContainer, StyledLeadContainer, StyledflexSpacebetween } from './Styled';
import { useState } from 'react';
import { Autocomplete, Button, TextField } from '@mui/material';
import DataGridTable from './DataGrid';
import { handleValidateCodevalue } from '../Utility/constant';
import { useSelector } from 'react-redux';

const RolePermissionComponenet = ({isViewMode = false ,selectedaddedValue, handleSelectedAddValue, isEdit = false, isCreate = false, columns = [], label, placeholder, dataGridData = [], dropdownlist,  handleSelectedValue}) => {

    const [required, setRequired] = useState(false);
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData
    )
    const handleAdd = () => {
        if(selectedaddedValue) {
            handleSelectedAddValue();
        } else {
            setRequired(true);
        }
    }
    return (
        <React.Fragment>
            {!isViewMode &&
            <StyledLeadContainer>
                <Autocomplete
                    // multiple
                    options={dropdownlist}
                    sx={{width: true ? '50ch !important' : "65ch !important", padding: "0px", display: 'flex'}}
                    getOptionLabel={(option) => option?.name}
                    value={selectedaddedValue}
                    filterSelectedOptions = {true}
                    // filterOptions={handleFilterOption}
                    // disableCloseOnSelect
                    limitTags={2}
                    onChange={handleSelectedValue}
                    renderInput={(params) => (
                    <TextField
                        {...params}
                        required={true}
                        error={selectedaddedValue ? false : required}
                        // required
                        variant='standard'
                        label={label}
                        sx={{width: true ? '50ch !important' : "65ch !important" , padding: "0px" }}
                        placeholder={placeholder}
                        InputLabelProps={{
                        shrink: true,
                    }}
                    />
                    )}
                />
                 <Button variant="contained" className='edit-primary' size="large" onClick={handleAdd}>{handleValidateCodevalue(internationalise,'COMMON_ADD')}</Button>
            </StyledLeadContainer>
            }
             <StyledCenterContainer>
                <DataGridTable
                    height='calc(100vh - 500px)'
                    columns={columns}
                    dataGridData={dataGridData}
                    isCheckboxReq = {false}
                    isRequiredToolBar = {false}
                />
            </StyledCenterContainer>
        </React.Fragment>
    )
}

export default RolePermissionComponenet;